import type { FaireProductEntity } from "../../entity_types/product";

export const p_5tdzyzi6xu: FaireProductEntity = {
  token: "p_5tdzyzi6xu",
  type: "product",
  name: "ANXIETY RELIEF  | 10 ml",
  brandToken: "b_5dagse75md",
  brandName: "Rowe Casa Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/2d7cd31b5d5af7bc380f4becaf912995609ec10e50c8dda8a57cee775cfe5225.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/062d972f6d4d5af4d6efc1321930d41d96d03df44787ea17c10b6e5b2710869d.png",
  ],
  priceDollars: 23.8,
  description:
    'This 100% pure, therapeutic grade essential oil wellness blend is a must have to help ground, center, and relax the emotional center of the brain, supporting emotional equilibrium. It is great for calming the nervous system, improving mood, and calming feelings of high stress and anxiety.\n\nTO USE: Apply desired amount onto inner wrists, forehead, or under nose as needed.\n\nINGREDIENTS: ORGANIC UNREFINED COLD PRESSED AVOCADO OIL, 100% PURE THERAPEUTIC GRADE ESSENTIAL OILS: LAVENDER, COPAIBA, LIME, CEDARWOOD, VANILLA, OCOTEA, CAPRIC TRIGLYCERIDE, BLACK SPRUCE, CAMPHOR, BLUE TANSY, FRANKINCENSE, GERANIUM, PATCHOULI, VETIVER.\n\nDimension: 10 ml, 0.75" x 3.25" x 0.75".',
  tags: [],
  msrpDollars: 34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:11.975Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
